/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../Fixes';
import Builder from '../../../../../Builder';
import '../interfaces/retrieve-catalog-obj';
import '../interfaces/delete-catalog-obj';
import '../interfaces/upsert-catalog-object';
import '../interfaces/update-catalog-objects';
import '../interfaces/list-catalog';
import '../interfaces/batch-upsert-catalog-obj';
import '../interfaces/batch-retrieve-catalog-obj';
import '../interfaces/search-catalog-obj';
import '../interfaces/batch-delete-catalog-obj';
import '../interfaces/update-item-taxes';
import '../interfaces/update-item-modifier-lists';
import '../interfaces/catalog-info';
import '../interfaces/count-catalog-objects';
import '../interfaces/search-catalog-items';
import '../interfaces/search-catalog-item-variations';
import '../interfaces/search-catalog-images';
import '../interfaces/catalog-configuration';
import '../interfaces/update-catalog-configuration';
import '../interfaces/sync-catalog-obj';
import '../interfaces/catalog-object-history';
import '../interfaces/create-catalog-image';
import '../interfaces/update-catalog-image';
import '../interfaces/clone-category';
import '../interfaces/clone-menu';
import '../interfaces/clone-grid';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "connect": {
        "nested": {
          "v2": {
            "nested": {
              "merchant_catalog": {
                "nested": {
                  "frontend": {
                    "nested": {
                      "ListAuthorizedCustomAttributeDefinitionsRequest": {
                        "fields": {
                          "cursor": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "includeCounts": {
                            "type": "bool",
                            "id": 2,
                            "rule": "optional",
                            "options": {
                              "default": false
                            }
                          }
                        }
                      },
                      "MerchantCatalogConnectFrontend": {
                        "methods": {
                          "RetrieveCatalogObject": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.RetrieveCatalogObjectRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.RetrieveCatalogObjectResponse"
                          },
                          "DeleteCatalogObject": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.DeleteCatalogObjectRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.DeleteCatalogObjectResponse"
                          },
                          "UpsertCatalogObject": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.UpsertCatalogObjectRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.UpsertCatalogObjectResponse"
                          },
                          "UpdateCatalogObjects": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.UpdateCatalogObjectsRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.UpdateCatalogObjectsResponse"
                          },
                          "ListCatalog": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.ListCatalogRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.ListCatalogResponse"
                          },
                          "BatchUpsertCatalogObjects": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.BatchUpsertCatalogObjectsRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.BatchUpsertCatalogObjectsResponse"
                          },
                          "BatchRetrieveCatalogObjects": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.BatchRetrieveCatalogObjectsRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.BatchRetrieveCatalogObjectsResponse"
                          },
                          "SearchCatalogObjects": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogObjectsRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogObjectsResponse"
                          },
                          "BatchDeleteCatalogObjects": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.BatchDeleteCatalogObjectsRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.BatchDeleteCatalogObjectsResponse"
                          },
                          "UpdateItemTaxes": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.UpdateItemTaxesRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.UpdateItemTaxesResponse"
                          },
                          "UpdateItemModifierLists": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.UpdateItemModifierListsRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.UpdateItemModifierListsResponse"
                          },
                          "CatalogInfo": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.CatalogInfoRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.CatalogInfoResponse"
                          },
                          "CountCatalogObjects": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.CountCatalogObjectsRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.CountCatalogObjectsResponse"
                          },
                          "ListAuthorizedCustomAttributeDefinitions": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.frontend.ListAuthorizedCustomAttributeDefinitionsRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.ListCatalogResponse"
                          },
                          "SearchCatalogItems": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogItemsResponse"
                          },
                          "SearchCatalogItemVariations": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogItemVariationsRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogItemVariationsResponse"
                          },
                          "SearchCatalogImages": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.SearchCatalogImagesResponse"
                          },
                          "CatalogConfiguration": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.CatalogConfigurationRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.CatalogConfigurationResponse"
                          },
                          "UpdateCatalogConfiguration": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.UpdateCatalogConfigurationRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.UpdateCatalogConfigurationResponse"
                          },
                          "SyncCatalogObjects": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.SyncCatalogObjectsRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.SyncCatalogObjectsResponse"
                          },
                          "CatalogObjectHistory": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.CatalogObjectHistoryRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.CatalogObjectHistoryResponse"
                          },
                          "CreateCatalogImage": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.CreateCatalogImageRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.CreateCatalogImageResponse"
                          },
                          "UpdateCatalogImage": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.UpdateCatalogImageRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.UpdateCatalogImageResponse"
                          },
                          "CloneCategory": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.CloneCategoryRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.CloneCategoryResponse"
                          },
                          "CloneMenu": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.CloneMenuRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.CloneMenuResponse"
                          },
                          "CloneGrid": {
                            "requestType": ".squareup.connect.v2.merchant_catalog.service.CloneGridRequest",
                            "responseType": ".squareup.connect.v2.merchant_catalog.service.CloneGridResponse"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.frontend?.nested?.ListAuthorizedCustomAttributeDefinitionsRequest && !$root.nested?.squareup?.nested?.connect?.nested?.v2?.nested?.merchant_catalog?.nested?.frontend?.nested?.MerchantCatalogConnectFrontend) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListAuthorizedCustomAttributeDefinitionsRequest @ squareup/connect/v2/catalog/frontend/catalog_connect_frontend.proto at 36:1
 */
export const ListAuthorizedCustomAttributeDefinitionsRequest = $root.lookupType('squareup.connect.v2.merchant_catalog.frontend.ListAuthorizedCustomAttributeDefinitionsRequest');
fixType(ListAuthorizedCustomAttributeDefinitionsRequest);
Builder.createAndAttachToType(ListAuthorizedCustomAttributeDefinitionsRequest);
/**
 * SOURCE MerchantCatalogConnectFrontend @ squareup/connect/v2/catalog/frontend/catalog_connect_frontend.proto at 51:1
 */
export const MerchantCatalogConnectFrontend = $root.lookupService('squareup.connect.v2.merchant_catalog.frontend.MerchantCatalogConnectFrontend');